export const getStripeUrl = (path?: string) =>
  `https://dashboard.stripe.com${
    process.env.REACT_APP_API_DOMAIN?.includes('staging') ? '/test' : ''
  }${path || ''}`
